export const STYLES = {
  // Page Layout
  pageContainer: "max-w-7xl mx-auto space-y-6 pb-20 md:pb-0",
  
  // Headers
  pageHeader: {
    wrapper: "flex flex-col md:flex-row md:items-end justify-between gap-4 mb-6",
    title: "text-3xl md:text-4xl font-bold text-gray-900 tracking-tight",
    subtitle: "text-gray-500 mt-1 text-base md:text-lg",
  },

  // Cards
  card: {
    base: "bg-white rounded-3xl border border-gray-100 shadow-sm",
    hover: "hover:shadow-lg hover:border-gray-200 transition-all duration-300",
    padding: "p-6 md:p-8",
    interactive: "cursor-pointer transition-all hover:scale-[1.01] active:scale-[0.99]",
  },

  // Form Elements
  input: {
    base: "w-full p-3 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-clip-200 focus:border-clip-400 outline-none font-medium transition-all placeholder:text-gray-400 text-gray-900",
    label: "block text-xs font-bold text-gray-400 uppercase tracking-wider mb-2 flex items-center gap-2",
  },

  // Buttons (variants handled in component, this is base)
  button: {
    base: "flex items-center justify-center gap-2 px-5 py-2.5 font-bold rounded-xl transition-all active:scale-95 shadow-sm",
  },

  // Status Badges
  badge: {
    base: "px-2.5 py-1 rounded-full text-xs font-bold border flex items-center gap-1",
    success: "bg-green-50 text-green-700 border-green-100",
    danger: "bg-red-50 text-red-700 border-red-100",
    warning: "bg-amber-50 text-amber-700 border-amber-100",
    neutral: "bg-gray-50 text-gray-600 border-gray-100",
  }
};